import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MedicalCaseIconComponent } from '@kuiper/icons';
import { MaintenanceModeService } from '../../services/maintenance-mode/maintenance-mode.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-maintenance-mode',
  imports: [MedicalCaseIconComponent, TranslocoPipe],
  templateUrl: './maintenance-mode.component.html',
  styleUrl: './maintenance-mode.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MaintenanceModeComponent {
  maintenanceModeService = inject(MaintenanceModeService);

  show = computed(() => this.maintenanceModeService.showMaintenanceMode());
}
